import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import Amplify, { Auth } from "aws-amplify";
import { AmplifyProvider } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { CONFIGS } from "./constants/AppConstant";
const oauth = {
  domain: CONFIGS.LOGIN_DOMAIN,
  scope: ["email", "openid", "profile"],
  redirectSignIn: window.location.origin + "/oauth2/idpresponse",
  redirectSignOut: window.location.origin + "/logout",
  responseType: "code",
};

Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: CONFIGS.REGION,
    userPoolId: CONFIGS.USER_POOL_ID,
    userPoolWebClientId: CONFIGS.USER_POOL_CLIENT_ID,
    identityPoolId: CONFIGS.IDENTITY_POOL_ID,
    authenticationFlowType: "USER_PASSWORD_AUTH",
    oauth: oauth,
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <AmplifyProvider>
//       <App />
//     </AmplifyProvider>
//   </React.StrictMode>
// );
root.render(
  <AmplifyProvider>
    <App />
  </AmplifyProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
